export default {
  title: 'マーケティング活動',
  activityManagement: 'アクティビティ管理',
  activityList: 'アクティビティ一覧',
  drawRecord: '抽選記録',
  giftClaimRecord: 'ギフト受け取り記録',
  activityTemplate: 'アクティビティテンプレート',
  marketingData: 'マーケティングデータ',
};
